import type { ReactNode } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Search } from '~/components/icons';
import { Button, EmptyState } from '~/components/ui';

/**
 * Route-level 404 — the router's `defaultNotFoundComponent`, rendered for an
 * unmatched path or a `notFound()` thrown from a loader. Sends the user back to
 * the app entry (which routes them to dashboard or sign-in depending on auth).
 */
export function RouteNotFound(): ReactNode {
  const navigate = useNavigate();
  return (
    <EmptyState
      data-testid="route-not-found"
      icon={<Search size={48} />}
      title="Page not found"
      description="The page you're looking for doesn't exist or may have moved."
      actions={
        <Button onClick={() => void navigate({ to: '/' })} data-testid="route-not-found-home">
          Go home
        </Button>
      }
    />
  );
}
